import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import useEmployeeDetails from "../hooks/useEmployeeDetails";

export default function LeavesHistory() {
    const { id, employeeToken } = useEmployeeDetails();
    const API_URL = process.env.REACT_APP_BASE_URL;
    const [teamRequests, setTeamRequests] = useState([]);

    const fetchRequests = useCallback(async () => {
        try {
            const res = await axios.post(
                `${API_URL}/get_staff_leave_requests`,
                { reporting_manager: id, status: ["approved", "rejected"] },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${employeeToken}`,
                    },
                }
            );
            if (res.data?.employeeLeaveRequests) {
                setTeamRequests(res.data.employeeLeaveRequests);
            } else {
                toast.info("No leave requests found.");
            }
        } catch (err) {
            toast.error(err.response?.data?.message || "Error fetching requests.");
        }
    },[id,API_URL,employeeToken])

    useEffect(() => {
        if (id)
            fetchRequests();
    }, [id,fetchRequests]);

    const getDuration = (start, end) => {
        const startDate = moment(start);
        const endDate = moment(end);
        return endDate.diff(startDate, "days") + 1;
    };

    // const handleStatusChange = async (requestId, status) => {
    //     try {
    //         const res = await axios.post(
    //             `${API_URL}/approve_reject_leave_request`,
    //             { requestId, status },
    //             {
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                     Authorization: `Bearer ${employeeToken}`,
    //                 },}
    //         );
    //         if (res.data?.success) {
    //             toast.success(res.data.message || `Leave ${status} successfully.`);
    //             fetchRequests(); // Refresh list
    //         } else {
    //             toast.error(res.data.message || `Failed to ${status} leave.`);
    //         }
    //     } catch (error) {
    //         toast.error(error.response?.data?.message || `Failed to ${status} leave.`);
    //     }
    // };

    return (
        <div className="px-3 max-w-2xl mx-auto">
            <ToastContainer />
            {teamRequests.length === 0 ? (
                <p className="text-gray-500 text-center">No leave requests yet.</p>
            ) : (
                <div className="space-y-3">
                    {teamRequests.map((req) => {
                        const emp = req.emp || {};
                        const fullName = `${emp.first_name} ${emp.last_name}`;
                        const createdAt = moment(req.created_at).format("DD MMM YY");
                        const fromDate = moment(req.start_date).format("DD MMM");
                        const toDate = moment(req.end_date).format("DD MMM YYYY");
                        const duration = getDuration(req.start_date, req.end_date);
                        const updatedAt = moment(req.updated_at).format("DD MMM YY, hh:mm A");

                        return (
                            <div
                                key={req._id}
                                className="bg-white shadow-sm rounded-xl border border-gray-200 space-y-1"
                            >
                                <div className="p-3 space-y-1">
                                    {/* Top: Name + Applied On */}
                                    <div className="flex justify-between items-start">
                                        <div className="text-sm font-semibold text-gray-800">
                                            {fullName}
                                        </div>
                                        <div className="text-right text-[10px] text-gray-400 leading-tight">
                                            <p className="font-light">Applied On</p>
                                            <p>{createdAt}</p>
                                        </div>
                                    </div>

                                    {/* Leave Type */}
                                    {req.leave_type && (
                                        <div className="border border-green-500 text-green-700 rounded-md inline-block text-xs px-2 py-0.5 font-medium">
                                            {req.leave_type
                                                .replace(/_/g, " ")
                                                .toLowerCase()
                                                .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase())}
                                        </div>
                                    )}

                                    {/* Leave Date */}
                                    <div className="text-xs text-gray-700 font-medium">
                                        <span className="font-semibold text-gray-600">Leave Date: </span>
                                        {fromDate} - {toDate}
                                    </div>

                                    {/* Duration */}
                                    <div className="text-xs text-gray-600">
                                        <span className="font-semibold text-gray-600">
                                            Duration&nbsp;&nbsp; &nbsp; :&nbsp;
                                        </span>
                                        {duration} {duration > 1 ? "days" : "day"}
                                    </div>

                                    {/* Reason */}
                                    {req.reason?.trim() && (
                                        <div className="text-xs text-gray-700">
                                            <span className="font-semibold">Reason &nbsp; &nbsp; &nbsp; : </span>
                                            {req.reason}
                                        </div>
                                    )}

                                    {/* Status */}
                                    {req.status && (
                                        <div className="text-xs text-gray-700 font-semibold">
                                            <span className="text-gray-600">Status &nbsp; &nbsp; &nbsp; &nbsp; : </span>
                                            <span
                                                className={`${req.status === "approved"
                                                    ? "text-green-600"
                                                    : req.status === "rejected"
                                                        ? "text-red-600"
                                                        : "text-gray-600"
                                                    } uppercase`}
                                            >
                                                {req.status}
                                            </span>
                                        </div>
                                    )}

                                    {/* Updated At */}
                                    <div className="text-xs text-gray-700">
                                        <span className="font-semibold">Updated At: </span>
                                        {updatedAt}
                                    </div>
                                    {/* <div className="text-xs text-gray-700">
                                        <span className="font-semibold">Updated At:&nbsp;</span>
                                        {moment(req.updated_at).subtract(5, 'hours').subtract(30, 'minutes').format("DD MMM YY hh:mm A")}
                                    </div> */}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
